// extracted by mini-css-extract-plugin
module.exports = {"tooltip_container":"ProgressBarTooltip_tooltip_container__3mVwf","label":"ProgressBarTooltip_label__1npFx"};